import { PluginDefinition } from 'yam-types'
import DeployWorkloadOperator from './handlers/deploy'
import yamlResourceOperator from './handlers/yaml-resource'
import initImageRegistry from './handlers/initialize'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'
import { DeployWorkload, NativeYamlResource } from './types.d'

export default {
  name,
  schema,
  settings,
  version,
  handlers: {
    'beforePlan': initImageRegistry,
    'prepare[?(@.type=="yaml")]': yamlResourceOperator,
    'deploy': DeployWorkloadOperator
  }
} as PluginDefinition<DeployWorkload | NativeYamlResource>
